/**
 * @author wql
 * @description  路径详情页
 * @Date  2020/7/17
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool, utils_tool } from '@/tool';
import { columns } from './config'


let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool

class TrainPathStageScoreRuleDetail extends WizContainer {
  componentName = 'trainPathStageScoreRuleDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/trainPathStageScoreRule/trainPathStageScoreRuleUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('trainPathStageScoreRuleUpd', initialValue)
      } else {
        initialValue = Session.get('trainPathStageScoreRuleUpd') || {};
      }
      cardTitle = '编辑'
    }
    this.state = {
      cardTitle: cardTitle,
      scoreId:initialValue.id,
    }
    this.initialValue = initialValue;
    this.clearWizCallBack = [];
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/trainPathStageScoreRule/trainPathStageScoreRuleUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('trainPathStageScoreRuleUpd', initialValue)
      } else {
        initialValue = Session.get('trainPathStageScoreRuleUpd') || {};
      }
    }
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this.setState({scoreId:initialValue.id})
    }
  }

  propsAndStateOnChange = {
    addTrainPath: this._saveOver.bind(this, 'addTrainPath'),
    updTrainPath: this._saveOver.bind(this, 'updTrainPath')
  }


  _saveOver(key, nextProps, nextState) {//跳转操作
    let _key = nextProps[key];
    let { success, msg } = _key
    if (success) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/trainPathStageScoreRule');
      return true
    }
    wizNotice.error('提交失败：' + msg);
    return false;
  }


  // 将历史trainPathTaskScoreRules 中的id 加入到对应的匹配项中
  _joinRuleId = (entityId) => {
    let filterId = this.initialValue.trainPathTaskScoreRules.filter(e => e.entityId == entityId)
    return filterId[0]['id']
  }


  /**
 * 新增
 * @param values
 * @private
 */
  _save(values) {
    let allKeys = Object.keys(values) // 获取表单所有key
    let filterItem = allKeys.filter(e => e.includes('item-')) // item-xx:value 为所有任务集合 xx为entityId, value为任务占比

    // 反正出现选了阶段 没有任务选项,此补偿只是加一层提示语
    if (filterItem.length === 0) {
      wizNotice.error(`没有可选阶段任务`);
      return
    }

    // 最终要发送的trainPathStageScoreRuleCmds 内容
    let taskInfo = filterItem.map(e => {
      let entityId = e.split('-')[1]
      return {
        entityId,
        taskRatio: values[e],
        id: this.state.cardTitle === '编辑' ? this._joinRuleId(entityId) : ''
      }
    })

    // 计算总分值
    let allRatioNum = taskInfo.map(e => e.taskRatio).reduce((p, t) => p + t)

    if (allRatioNum !== 100) {
      wizNotice.error(`阶段任务总占比应为100%,当前总占比${allRatioNum}%`);
      return
    }

    // 提交
    const { history } = this.props;
    let apiPath = 'trainPathStageScoreRule/add';
    let payloadKey = 'trainPathStageScoreRule@add';
    if (history.location && history.location.pathname === '/trainPathStageScoreRule/trainPathStageScoreRuleUpd') {//做判断是新增还是修改，默认走add接口
      apiPath = 'trainPathStageScoreRule/upd';
      payloadKey = 'trainPathStageScoreRule@upd';
    }

    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          id: values['id'],
          entityId: values['entityId'],
          state: 2,
          trainPathStageScoreRuleCmds: taskInfo
        }
      }
    });
  };


  _render() {
    const { trainPathStageScoreRuleLoading } = this.props;

    let onSubmit = this._save.bind(this);

    let formProps = {
      ref: 'form',
      key: this.state.scoreId || '', // ⭐如缓存路由需要刷新,必须加标识key
      columns: columns(this),
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      ref: (ref) => this.formRef = ref,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }
    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={trainPathStageScoreRuleLoading}>
          <WizForm key='trainPathForm' className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { trainPathStageScoreRule } = state;
  const addTrainPath = modelUtils.getModelEntity(trainPathStageScoreRule, 'trainPathStageScoreRule@add');
  const updTrainPath = modelUtils.getModelEntity(trainPathStageScoreRule, 'trainPathStageScoreRule@upd');
  const load = modelUtils.getLoadingState(state, ['trainPathStageScoreRule']);
  return {
    addTrainPath,
    updTrainPath,
    ...load
  }
};

export default connect(mapStateToProps)(TrainPathStageScoreRuleDetail);
